<template>
  <v-app>
    <router-view />

  </v-app>
</template>

<script>
// import HelloWorld from './components/organisms/HelloWorld.vue';

export default {
  name: 'App',
  components: {
    // HelloWorld,
  },
  data() {
    return {
      //
    };
  },
};
</script>

<style>

.v-btn:hover:before {color: white }
.v-btn:focus:before { color: transparent}
</style>
